export function isRepeatSpec(spec) {
  return spec['repeat'] !== undefined;
}